const setEmployersParams = urlParams => {
  if (!urlParams) return;
  const { query, searchAfter = [] } = urlParams;
  // get job postings
  const uriQ =
    query && query.trim() ? `query=${encodeURIComponent(query.trim())}` : '';
  const uriSearchAfter = searchAfter.length
    ? `searchAfter=[${searchAfter
        .map(item => encodeURIComponent(item))
        .join(',')}]`
    : '';
  const params = [uriQ, uriSearchAfter].filter(p => !!p).join('&');

  return params;
};

export default setEmployersParams;
